// extracted by mini-css-extract-plugin
module.exports = {"card":"BigFiveCareerPaths_card__2vTFe","list":"BigFiveCareerPaths_list__3ORrH","loader":"BigFiveCareerPaths_loader__1aMc8","info":"BigFiveCareerPaths_info__2JJ6V"};